export function waitForElement(selector, { root = document, timeout = 10000 } = {}) {
    return new Promise((resolve, reject) => {
        const found = root.querySelector(selector);
        if (found) return resolve(found);

        const observer = new MutationObserver(() => {
            const el = root.querySelector(selector);
            if (el) {
                observer.disconnect();
                resolve(el);
            }
        });

        observer.observe(root === document ? document.documentElement : root, {
            childList: true,
            subtree: true,
        });

        if (timeout != null) {
            setTimeout(() => {
                observer.disconnect();
                reject(new Error(`waitForElement timeout: ${selector}`));
            }, timeout);
        }
    });
}